import type { FC } from 'react';
import { useMemo } from 'react';
import { SECTION_NAMES } from '@repo/common';
import { DefaultSectionHeader } from 'layouts/Section/SectionHeader';
import sectionStyles from 'layouts/Section/Section.module.css';
import TopWinFeaturedCard from '../TopWinFeaturedCard';
import { useTopWins } from '../../hooks/useTopWins';
import { buildTopWinsList } from '../../utils/buildTopWinsList';
import styles from './SingleViewTopWins.module.css';

/**
 * Single-view Top Wins tab: a static list of every win as a featured-style card.
 * The first card is the "main" one (yellow amount + glow); the rest are 'plain'
 * (white amount, no glow). No animations; data is fetched once on mount.
 */
const SingleViewTopWins: FC = () => {
  const { featured, recent } = useTopWins();

  const wins = useMemo(() => buildTopWinsList(featured, recent), [featured, recent]);

  return (
    <div
      className={sectionStyles.sectionContainer}
      data-view="single"
      data-active="true"
      data-section={SECTION_NAMES.TOP_WIN_GAMES}
    >
      <DefaultSectionHeader name={SECTION_NAMES.TOP_WIN_GAMES} isActive gamesCount={wins.length} />
      {/* Same body wrapper the generic Section uses in single view, so spacing matches. */}
      <div className={sectionStyles.sectionBody} data-view="single">
        <div className={styles.grid}>
          {wins.map((win, index) => (
            <TopWinFeaturedCard
              key={win.id}
              win={win}
              variant={index === 0 ? 'main' : 'plain'}
              view="single"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SingleViewTopWins;
